// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@werner/App/Libraries";
import "@werner/App/Store/Reducers";
import "@werner/XDL";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./App/Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () =>
        onHotWidgetReplace(require.context("./App/Widgets", true, /\.tsx$/)),
    );
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./App/Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./App/Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));
// const widgetExtensions = require.context("./WidgetExtensions", true);
// widgetExtensions.keys().forEach(key => widgetExtensions(key));

// Load all the extensions to the base pages. This includes style extensions.
const pagesExtensions = require.context("./App/PagesExtensions", true);
pagesExtensions.keys().forEach(key => pagesExtensions(key));

// Load all the extensions to the base components. This includes style extensions.
const componentExtensions = require.context("./App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));

/**
 * Google Analytics Integration
 * Step: To enable Google Analytics, add below code to your start.tsx file
 */
import "@werner/App/GoogleAnalyticsConnector/Store/Reducers";

// load all widgets. Without this they won't be included in the bundle
const GoogleAnalyticsWidgets = require.context("./App/GoogleAnalyticsConnector/Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onGoogleAnalyticsHotWidgetReplace = addWidgetsFromContext(GoogleAnalyticsWidgets);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(GoogleAnalyticsWidgets.id.toString(), () =>
        onGoogleAnalyticsHotWidgetReplace(require.context("./App/GoogleAnalyticsConnector/Widgets", true, /\.tsx$/)),
    );
}

const googleAnalyticsHandlers = require.context("./App/GoogleAnalyticsConnector/Handlers", true);
googleAnalyticsHandlers.keys().forEach(key => googleAnalyticsHandlers(key));
/**
 * End Google Analytics Integration
 */
